import React from "react";
import _ from "lodash";
import { GroupsTwoTone, ChevronRight, VerifiedUser, BusinessTwoTone } from "@mui/icons-material";
import moment from "moment";
import { wholeNumberWithCommas } from "../utils/NumberFormatter";
import MixpanelService from "../utils/MixpanelService";
import { PersonTwoTone } from "@material-ui/icons";
import { calculatePercentage } from "../utils/Helpers";

const StatCards = (props) => {
  const renderUser = () => {
    // icon should be green when active, gray when inactivate
    const iconColor = props.user_2fa ? "#2BD67B" : "#DEE5EB";
    const iconLabel = props.user_2fa ? "ON" : "OFF";
    return (
      <>
        <div className="t--lg t--500">{props.user_name}</div>
        <div className="t--sm t--subtitle t--secondary">{props.user_email}</div>
        <div className="tile__footer tile__footer--spread tile__footer--mt-a">
          <div>
            <VerifiedUser htmlColor={iconColor} fontSize={"small"} />
            <span style={{ marginLeft: 5 }}>
              <a href={props.user_settings_path}>2FA: {iconLabel}</a>
            </span>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <div className="div1">
        <div className="tile__well" style={{ height: "100%" }}>
          <div className="tile">
            <div className="tile__header tile__header--spread" style={{ paddingBottom: 6 }}>
              <PersonTwoTone htmlColor={"#3246D3"} fontSize={"large"} />
              <a href={`/organizations/${props.organization}/edit`}>
                <div className="btn btn--sqr">
                  <ChevronRight fontSize="small" />
                </div>
              </a>
            </div>
            {renderUser()}
          </div>
        </div>
      </div>
      <div className="div2">
        <div className="tile__well" style={{ height: "100%" }}>
          <div className="tile">
            <div className="tile__header tile__header--spread">
              <div className="t--md t--500 t--navyblue">Registered Entities</div>
              <a href={props.entity_path}>
                <div className="btn btn--sqr">
                  <ChevronRight fontSize="small" />
                </div>
              </a>
            </div>
            <div className="t--500 t--xl">{props.entities_count}</div>
            <div className="tile__footer tile__footer--spread tile__footer--mt-a">
              <div>Total Contract Pharmacies</div>
              <div>{props.cp_count}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="div3">
        <div className="tile__well" style={{ height: "100%" }}>
          <div className="tile">
            <div className="tile__header tile__header--spread">
              <div className="t--md t--500 t--navyblue">Total Claims</div>
              <a
                href={`/organization/${props.organization}/reports`}
                onClick={() =>
                  MixpanelService.track("esp_conforming_claims_card_view_reports_clicked")
                }
              >
                <div className="btn btn--sqr">
                  <ChevronRight fontSize="small" />
                </div>
              </a>
            </div>
            <div className="flex__container flex__container--align-center">
              <div className="t--500 t--xl">
                {wholeNumberWithCommas(props.total_claims_count[moment().format("MM")])}
              </div>
              <div className="t--sm ml-2">This Month</div>
            </div>
            <div className="tile__footer tile__footer--spread tile__footer--mt-a">
              <div>Last Month</div>
              <div>
                {wholeNumberWithCommas(
                  props.total_claims_count[moment().subtract(1, "month").format("MM")]
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="div4">
        <div className="tile__well" style={{ height: "100%" }}>
          <div className="tile">
            <div className="tile__header tile__header--spread">
              <div className="t--md t--500 t--navyblue">% Conforming Claims</div>
              <a
                href={`/organization/${props.organization}/reports`}
                onClick={() =>
                  MixpanelService.track("esp_conforming_claims_card_view_reports_clicked")
                }
              >
                <div className="btn btn--sqr">
                  <ChevronRight fontSize="small" />
                </div>
              </a>
            </div>
            <div className="flex__container flex__container--align-center">
              <div className="t--500 t--xl">
                {calculatePercentage(
                  props.conforming_claims_count[moment().format("MM")],
                  props.total_claims_count[moment().format("MM")]
                )}
                %
              </div>
              <div className="t--sm ml-2">This Month</div>
            </div>
            <div className="tile__footer tile__footer--spread tile__footer--mt-a">
              <div>Last Month</div>
              <div>
                {calculatePercentage(
                  props.conforming_claims_count[moment().subtract(1, "month").format("MM")],
                  props.total_claims_count[moment().subtract(1, "month").format("MM")]
                )}
                %
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StatCards;
